import { oauthGoogleSession } from '@/services/oauth-google-session'

export const useAPIOauthGoogleSession = () => {
  const handleAPIOauthGoogleSession = async (redirectUri: string, agentId?: string) => {
    return await oauthGoogleSession(redirectUri, agentId)
  }

  return {
    handleAPIOauthGoogleSession,
  }
}
